export default __webpack_public_path__ + "static/media/facebook.23253bc0.svg";